
class exports.BaseStep extends KoModel

    constructor: (parent) ->
        super()
        @__destroyed = false
        @parent = parent
        @ignore 'prev'
        @__name = ko.observable()


    # Before we go "back" from this step
    beforePrev: () ->
        @destroy()


    # After we've gone "back" from this step
    afterPrev: () ->
        undefined


    # Before this step is set as the current step
    beforeSet: () ->
        undefined


    # After this step is set as the current step
    afterSet: () ->
        undefined


    # Before we progress to the next step
    beforeNext: () ->
        @destroy()


    # After we progress to the next step
    afterNext: () ->
        undefined


    # By default, returns the previous item on the parent's history
    getPrev: () =>
        # gets the most recent previous item
        return @parent.clearHistoryPrev()


    # clean up anything in here
    destroy: () ->
        if @__destroyed
            return

        @__destroyed = true


    # stub that is overwritten by steps that need validation
    validate: () =>
        return true
